module.exports = __webpack_public_path__ + "media/images/emblems/Koppigen-coat_of_arms-24e1429cbb86ac3b3a6f3de3e0dc3a72.svg";